import mori from 'mori';
import { sheetParseConfig as c } from  '../config/config';

/**
 * A transducer that creates the timeframe list
 * @param {array} sheets - The flat gdocs json data
 * @return {array} An array of timeframes
 */
export default function(sheets) {
  return mori.intoArray(mori.transduce(
    mori.comp(
      // exclude config sheets
      mori.filter((x) => c.configTitles.indexOf(x[0].toLowerCase()) === -1),
      mori.map((x) => x[0])
    ),
    mori.completing(mori.conj),
    mori.vector(),
    sheets
  ));
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/timeframeFilters.js
 **/